import MojitoPresentation from 'mojito/presentation';
import CountryOrSportIcon from 'modules/country-or-sport-icon/index.js';

const { FlexPane, Image, Text } = MojitoPresentation.Components;

const CmsCouponsListHeader = props => {
    const {
        couponName,
        sportId,
        isPriceBoostedCoupon,
        isPreBuiltBetBuilderCoupon,
        mojitoTools: { config },
    } = props;
    let icon = <CountryOrSportIcon sportId={sportId} config={config.countryOrSportIcon} />;
    if (isPriceBoostedCoupon) {
        icon = <Image config={config.priceBoostedIcon} />;
    } else if (isPreBuiltBetBuilderCoupon) {
        icon = <Image config={config.matchAccaIcon} />;
    }
    return (
        <FlexPane config={config.header} class="ta-CmsCouponsListHeader">
            {icon}
            <Text config={config.title}>{couponName}</Text>
        </FlexPane>
    );
};

export default CmsCouponsListHeader;
